interface AlertProps {
	text: string
}

export const Alert = ({ text }: AlertProps) => {
	return <div className="border border-red-950 rounded bg-red-500 text-white pl-5 py-1">{text}</div>
}
